import React from 'react';

const Dashboard = React.lazy(() => import('./views/deployment/Dashboard'));
const ApplicationsPage = React.lazy(() => import('./views/deployment/ApplicationsPage'));
const ApplicationDetailPage = React.lazy(() => import('./views/deployment/ApplicationDetailPage'));
const SitesServersPage = React.lazy(() => import('./views/deployment/SitesServersPage'));
const SiteDetailPage = React.lazy(() => import('./views/deployment/SiteDetailPage'));
// eslint-disable-next-line import/extensions
const ServerDetailPage = React.lazy(() => import('./views/deployment/ServerDetailPage.js'));
const DeploymentWizardPage = React.lazy(() => import('./views/deployment/DeploymentWizardPage'));
const DeploymentsPage = React.lazy(() => import('./views/deployment/DeploymentsPage'));
const DeploymentRunDetailPage = React.lazy(() =>
  import('./views/deployment/DeploymentRunDetailPage')
);

const routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/home', exact: true, name: 'Home', component: Dashboard, protected: true },
  {
    path: '/applications',
    exact: true,
    name: 'Applications',
    component: ApplicationsPage,
    protected: true,
  },
  {
    path: '/applications/:applicationId',
    exact: true,
    name: 'Application Detail',
    component: ApplicationDetailPage,
    protected: true,
  },
  {
    path: '/sites',
    exact: true,
    name: 'Sites and Servers',
    component: SitesServersPage,
    protected: true,
  },
  {
    path: '/sites/:siteId',
    exact: true,
    name: 'Site Detail',
    component: SiteDetailPage,
    protected: true,
  },
  {
    path: '/sites/:siteId/servers/:serverId',
    exact: true,
    name: 'Server Detail',
    component: ServerDetailPage,
    protected: true,
  },
  {
    path: '/deployment/wizard',
    exact: true,
    name: 'Deployment Wizard',
    component: DeploymentWizardPage,
    protected: true,
  },
  {
    path: '/deployments',
    exact: true,
    name: 'Deployments',
    component: DeploymentsPage,
    protected: true,
  },
  {
    path: '/deployments/:runId',
    exact: true,
    name: 'Deployment Run Detail',
    component: DeploymentRunDetailPage,
    protected: true,
  },
];

export default routes;
